import { HTMLAttributes } from "react"
import { Product, SafeZone } from "../types"
import { booking, SCREEN_BREAKPOINT_2, MIN_AVAILABILITY_PERCENT_TO_DISPLAY_FIRE_ICON_IN_ZONES } from "../utils/symbols"
import { getZoneName, _, parseNum } from "../utils/helpers"
import { Icon } from "./Icon"
import { useApp } from "../context/useApp"

type ZoneCardProps = {
    product: Product
    zone: SafeZone
    active: boolean
    availability: number
    qty?: number
} & HTMLAttributes<HTMLButtonElement>

export const ZoneCard = ({zone, active, availability, product, qty, children, ...attributes }: ZoneCardProps) => {

    const {
        state: { screen }
    } = useApp()

    const zoneName = getZoneName('long', zone, booking.journey)
    const displayFireIcon = availability <= MIN_AVAILABILITY_PERCENT_TO_DISPLAY_FIRE_ICON_IN_ZONES && availability > 0
    const parsedFinalPrice = parseNum('EUR', product.price)
    const ariaLabel = `${zoneName} ${parsedFinalPrice}.`

    return (
        <button
        {...attributes}
        aria-label={ariaLabel}
        className={`zone jcsb df p-7 fd-c w-100 zone-${zone} r3 mb-6 p-r ${active  ? 'selected' : ''} ${availability === 0 ? 'disabled' : ''} button b-0 outline-shadow ${attributes.className||""} ${booking.hasTableSelection() ? "alternative" : ""}`}
        >
            <div className="df aic jcsb w-100" aria-hidden>
                <div className="text s20-600 w-100 df aic jcfs name cap zone-card-name" aria-hidden>
                    <p className="text mr-4 df aic" aria-hidden>
                        {qty !== undefined && qty > 0 && (
                            <span className="mr-3">{qty}x</span>
                        )}
                        {zoneName}
                    </p>
                    {product.category === 'children' && (<Icon icon={'children'} className="mr-3" />)}
                </div>

                {screen.width < SCREEN_BREAKPOINT_2 && displayFireIcon && booking.hasTableSelection() ? (
                    <Icon icon="fire" className="icon-group r2 mr-12" />
                ) : screen.width < SCREEN_BREAKPOINT_2 && availability === 0 ? (
                    <Icon icon="no-tickets" className="icon-group sold-out r2 mr-12" />
                ) : null}

                <p className="zone-card-price text s20-600 price" aria-hidden>
                    {product.discounts.length > 0 &&
                        <span className="text softer strikethrough mr-4 s18-500">
                            {parseNum('EUR', product.originalPrice)}
                        </span>
                    }
                    {parsedFinalPrice}
                </p>
            </div>
            {(!booking.hasTableSelection() || screen.width >= SCREEN_BREAKPOINT_2) && (
                <>
                    {
                        displayFireIcon ? (
                            <div className="df aic mt-7 w-fc icon-group px-5 py-3 r2" aria-hidden>
                                <p className="text s14-500 df" aria-hidden><Icon icon="fire" /><span>{_('0ge_onlya__')}</span></p>
                            </div>
                        ) : availability === 0 ? (
                            <div className="df aic mt-7 w-fc icon-group sold-out px-5 py-3 r2" aria-hidden>
                                <p className="text s14-500 df" aria-hidden><Icon icon="no-tickets" /><span>{_('1da_soldo__')}</span></p>
                            </div>
                        ) : null
                    }
                </>
            )}

        </button>
    )
}